import { Field, Formik } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Form, Jumbotron, Row } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import Get from '../../api/Get';
import { ACCOUNT_ACTIVE_ALL, COMPANY_ALL_ACTIVE, CORREOS_GET_BY_ID, CORREOS_SAVE, DELETE_FILE_CORREO, LANGUAGE_ACTIVE_ALL, UPLOAD_FILE_CORREO } from '../../api/Routes';
import { authContext } from '../../context/AuthContext';
import LoadingList from '../../loader/LoadingList';
import EmailEditor from 'react-email-editor';
import sample from '../../data/example.json';
import Post from '../../api/Post';
import { safelyParseJSON } from '../../utils/safelyParseJSON';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import SimpleLoad from '../../loader/SimpleLoad';
import { getIconDoc } from '../../utils/getIconDoc';
import moment from 'moment';
import { RiDeleteBin2Line } from 'react-icons/ri';
import { withTranslation } from 'react-i18next';
import { ImAttachment } from 'react-icons/im';
import PostFile from '../../api/PostFile';
import Delete from '../../api/Delete';

function FormCorreos({t, id,setEdit, edit}){
   // console.log(plantillaDefault)
    const {auth} = useContext(authContext)
    const history = useHistory()
    const [plantillaOpt, setPlantillaOpt] = useState([
        {
            key: 'platilla1', 
            name: "Plantilla default",
            design: sample
        }])
    const [plantDefault, setPlantiDefault] = useState('')
    const [errorGlobal, setErrorGlobal] = useState(null)
    const[showJodi, setShowJosi] = useState(false)
    const emailEditorRef = useRef(null);
    const [refVisible, setRefVisible] = useState(false)
    const [designToLoad, setDesignToLoad] = useState(null)
    const momentos = [
        {
            key: 'citaConfirmada',
            label: 'Cita confirmada'
        },
        {
            key: 'citaEnvioDocumentos',
            label: 'Cuando se envía los documentos de la cita'
        },
        {
            key: 'citaRecordatorio',
            label: 'Recordatorio de la cita'
        },
        {
            key: 'citaAutoagendamiento',
            label: 'Autoagendamiento de la cita'
        },
        {
            key: 'ikeBienvenido',
            label: 'Bienvenido'
        },
        {
            key: 'citaCancelada',
            label: 'Cita cancelada'
        },
        {
            key: 'citaCasoCovid',
            label: 'Cita caso COVID'
        },
        {
            key: 'ikeRecuperacionContraseña',
            label: 'Recuperación de contraseña'
        },
        {
            key: 'citaPendiente',
            label: 'Cita pendiente'
        },
        {
            key: 'onDemandNoDisponible',
            label: 'Alerta de Doctores no Disponibles Ondemand'
        },
        {
            key: 'citaPendientePorAutorizar',
            label: 'Cita pendiente por autorizar'
        },
        {
            key: 'medicoNoConectado',
            label: 'Médico no conectado'
        },
        {
            key: 'noDisponiblePC',
            label: 'No disponible PC'
        },
        {
            key: 'noDisponiblePedagogia',
            label: 'No disponible Pedagogía'
        },
        {
            key: 'citaReasignada',
            label: 'Reasignación de cita'
        },
        {
            key: 'checkup',
            label: 'Check up'
        },
        {
            key: 'encuestaIke',
            label: 'Encuesta Ike'
        },
        {
            key: 'reembolsoCitaCancelada',
            label: 'Reembolso de cita cancelada'
        },
        {
            key: 'citaRechazada',
            label: 'Cita rechazada'
        },
        {
            key: 'PendientePago',
            label: 'Pendiente de pago'
        },
        {
            key: 'CanceladaSinPago',
            label: 'Cancelada sin pago'
        }
    ]

    const [accountOpt, setAccountOpt] = useState([])
    const [companyOpt, setCompanyOpt] = useState([])
    const [languageOpt, setLanguageOpt] = useState([])

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        account: '',
        subject: '',
        company: '',
        language: '',
        appointmentMoment: '',
        paramFrom: '',
        paramCopy: '',
        phoneNumbers:'',
        paramTextSms: ''
    })

    //archivos
    const fileInputField = useRef(null);
    const [errorFile, setErrorFile] = useState('')
    const [loading, setLoading] = useState(false)
    const [archivos, setArchivos] = useState([])
    const [isDeleting, setIsDeleting] = useState(false)

    const shemaValidate = Yup.object().shape({
        name: Yup.string()
          .required('Campo Requerido'),
        account: Yup.string()
           .required('Campo Requerido'), 
        subject: Yup.string()
           .required('Campo Requerido'),   
        company: Yup.string()
           .required('Campo Requerido'),   
        language: Yup.string()
           .required('Campo Requerido'),
        appointmentMoment: Yup.string()
           .required('Campo Requerido'), 
        paramFrom: Yup.string()
           .required('Campo Requerido'),    
    });

    useEffect(()=>{
        Get({url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token})
        .then(response=>{
            setAccountOpt(response.data.data.response)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        Get({url: COMPANY_ALL_ACTIVE, access_token: auth.data.access_token})
        .then(response=>{
            setCompanyOpt(response.data.data.response)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        Get({url: LANGUAGE_ACTIVE_ALL, access_token: auth.data.access_token})
        .then(response=>{
            setLanguageOpt(response.data)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

     //buscar para editar el correo
     useEffect(()=>{
        if(id){
            Get({url: `${CORREOS_GET_BY_ID}/${id}`, access_token: auth.data.access_token})
            .then(response=>{
                console.log(response)
                let data = response.data.data
                let entity = {
                    id: data.id,
                    name: data.name,
                    account: data.account.id,
                    subject: data.subject,
                    company: data.company.id,
                    language: data.language.id,
                    appointmentMoment: data.appointmentMoment,
                    paramFrom: data.paramFrom,
                    paramCopy: data.paramCopy ?? '',
                    phoneNumbers:data.phoneNumbers?? '',
                    paramTextSms: data.paramTextSms ?? ''

                }          
                let arr = [...plantillaOpt]
                arr.push({
                    key: 'platilla2', 
                    name: "Mi plantilla",
                    design: safelyParseJSON(data.designJson) //JSON.parse(response.data.designJson)
                })  
                //console.log(arr)
                setPlantillaOpt(arr.filter(el=>el.key!=='platilla1'))                
                setDesignToLoad(safelyParseJSON(data.designJson)) //JSON.parse(response.data.designJson)                
                setInitialValues(entity)
                setArchivos(data.emailDocumentList)
                setEdit(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }else{
            setDesignToLoad(sample)
        }
    },[])

    const onHandleSelectPlantilla = (key) =>{
        setPlantiDefault(key)
        const seleccionada = plantillaOpt.filter(el=>el.key===key)
        if(seleccionada.length>0){
            setShowJosi(true)
            setDesignToLoad(seleccionada[0].design)
            //onLoad()
        }else{
            setShowJosi(false)
        }        
    }
    

    useEffect(() => {
        if (!refVisible) { 
          return;
        }else{
            if(emailEditorRef.current.editor && designToLoad){
                emailEditorRef.current.editor.loadDesign(designToLoad);
            }
        }        
      }, [refVisible, designToLoad])


    const getDesignJson = async() =>{
        try{
            return new Promise((resolve, reject)=>{
                emailEditorRef.current.saveDesign((design)=>{               
                    resolve(design)
                })
            })
        }catch(error){
            return null
        }  
    }
    const getDesignHtml = async() =>{
        try{
            return new Promise((resolve, reject)=>{
                emailEditorRef.current.exportHtml((data)=>{               
                    resolve(data.html)
                })
            })
        }catch(error){
            return null
        }  
    }

    const handleNewFileUpload = async (e) => {
        const file = e.target.files[0];

        if(file !== undefined){
            let fileExtension = file.name.split('.').pop();
        if(fileExtension==='exe' || fileExtension==='apk'){
            setErrorFile(t('documento_no_valido'))
        }else{
            if(file.size > 10485760){
                setErrorFile('El archivo no puede tener más de 10MB')
            }else{
                setErrorFile('')
                setLoading(true)
                const formData = new FormData()
                formData.append("file", file)
                formData.append("id", id)
                
                PostFile({url: UPLOAD_FILE_CORREO, data: formData, access_token: auth?.data?.access_token})
                .then(response=>{
                    console.log(response)
                    setArchivos(prev=>([...prev, response.data.data]))
                    setLoading(false)
                })
                .catch(error=>{
                    console.log(error)
                    setLoading(false)
                    setShowModalError(true)
                    if(error.response){
                        setErrorServer(error.response)
                    }
                })
            }
        }
        }
    };

    const deleteFile = (fileName, fileId) =>{     
        setIsDeleting(true)   
        let url = `${DELETE_FILE_CORREO}/${fileId}`
        Delete({url: url, access_token: auth?.data?.access_token})
        .then(response=>{
            setArchivos(archivos.filter(elem=>elem.id!==fileId))
            setIsDeleting(false)   
        })
        .catch(error=>{
            setShowModalError(true)
            setIsDeleting(false)   
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(
        <Row> 
            {
                (id && edit) ? <LoadingList texto="Cargando datos"/> :
                <Col>
                <Formik
                    initialValues={initialValues}
                    validationSchema={shemaValidate}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => { 

                        if(!showJodi && !values.id){
                            setSubmitting(false)
                            setErrorGlobal("Debes seleccionar la plantilla")
                        }else if(!showJodi && values.id){
                            let d = {
                                id: values.id,
                                name: values.name,
                                account: {id: values.account},  
                                company: {id: values.company},
                                language: {id: values.language},  
                                subject: values.subject,                                
                                appointmentMoment: values.appointmentMoment,
                                paramFrom: values.paramFrom,
                                active: true,
                                paramCopy: values.paramCopy,
                                phoneNumbers:values.phoneNumbers,
                                paramTextSms: values.paramTextSms
                            }
                            Post({url: CORREOS_SAVE,data: d, access_token: auth.data.access_token, header: true})
                            .then(response=>{
                                //console.log('ok')
                                setSubmitting(false)
                                history.replace('/admin/correos')                            
                            })
                            .catch(error=>{
                                setSubmitting(false)
                                setShowModalError(true)
                                if(error.response){
                                    setErrorServer(error.response)
                                }                          
                            })

                        }else{
                            let design  = await getDesignJson()
                            let html = await getDesignHtml()
                            let d = {
                                id: values.id,
                                name: values.name,
                                account: {id: values.account},  
                                company: {id: values.company},
                                language: {id: values.language},  
                                subject: values.subject,
                                paramBody: html,
                                designJson: JSON.stringify(design),
                                appointmentMoment: values.appointmentMoment,
                                paramFrom: values.paramFrom,
                                active: true,
                                paramCopy: values.paramCopy,
                                phoneNumbers:values.phoneNumbers,
                                paramTextSms: values.paramTextSms
                            }
                            Post({url: CORREOS_SAVE,data: d, access_token: auth.data.access_token, header: true})
                            .then(response=>{
                                //console.log('ok')
                                setSubmitting(false)
                                history.replace('/admin/correos')                            
                            })
                            .catch(error=>{
                                setSubmitting(false)
                                //console.log(error)                            
                            })
                        }
                    }}
                >{({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <Form onSubmit={handleSubmit}  className='mt-3'>
                        { isSubmitting && <LoadingList texto="Procesando petición"/> }
                        {
                            errorGlobal &&
                            <Alert variant="danger">
                                {errorGlobal}
                            </Alert>
                        }
                        <input type="hidden" name="id" value={values.id} />
                        <Card className="shadow-1">
                            <Card.Body>
                                <h4 className="text-color-4">Datos generales</h4>
                                <Row>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Nombre <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.name && 'error'}`}
                                                name="name"
                                            />
                                            { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Asunto <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.subject && 'error'}`}
                                                name="subject"
                                            />
                                            { errors.subject && <div className="invalid-feedback d-block">{errors.subject}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Cuenta de cliente corporativo <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                as="select"
                                                className={`form-control input-form ${errors.account && 'error'}`}
                                                name="account"
                                            >
                                                <option value="">Seleccionar</option>
                                                {
                                                    accountOpt.map((item,i)=>(
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    ))
                                                }
                                            </Field>
                                            { errors.account && <div className="invalid-feedback d-block">{errors.account}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Compañía <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                as="select"
                                                className={`form-control input-form ${errors.company && 'error'}`}
                                                name="company"
                                            >
                                                <option value="">Seleccionar</option>
                                                {
                                                    companyOpt.map((item,i)=>(
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    ))
                                                }
                                            </Field>
                                            { errors.company && <div className="invalid-feedback d-block">{errors.company}</div> }
                                        </Form.Group>
                                    </Col> 
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Lenguaje <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                as="select"
                                                className={`form-control input-form ${errors.language && 'error'}`}
                                                name="language"
                                            >
                                                <option value="">Seleccionar</option>
                                                {
                                                    languageOpt.map((item,i)=>(
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    ))
                                                }
                                            </Field>
                                            { errors.language && <div className="invalid-feedback d-block">{errors.language}</div> }
                                        </Form.Group>
                                    </Col> 
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Correo de envio <span className="text-danger">*</span></Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.paramFrom && 'error'}`}
                                                name="paramFrom"
                                            />
                                            { errors.paramFrom && <div className="invalid-feedback d-block">{errors.paramFrom}</div> }
                                        </Form.Group>
                                    </Col>  
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Correos a copiar</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.paramCopy && 'error'}`}
                                                name="paramCopy"
                                                placeholder="Lista de correos separados por coma, sin espacios en blanco. correo@dominio.com,correo2@dominio.com,correo3@dominio.com"
                                                
                                            />
                                            { errors.paramCopy && <div className="invalid-feedback d-block">{errors.paramCopy}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Números de Celular a incluir para Envío de alertas</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.phoneNumbers && 'error'}`}
                                                name="phoneNumbers"
                                                placeholder="Lista de números telefónicos separados por coma con el código de país 52 México y 57 Colombia, sin espacios en blanco. 529981111111,571234567890,525512345678"
                                            />
                                            { errors.phoneNumbers && <div className="invalid-feedback d-block">{errors.phoneNumbers}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Texto SMS</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-control input-form ${errors.paramTextSms && 'error'}`}
                                                name="paramTextSms"
                                            />
                                            { errors.paramTextSms && <div className="invalid-feedback d-block">{errors.paramTextSms}</div> }
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Row className="mt-2">
                            <Col xs="12" md="12">
                                <Row>
                                    <Col xs="12" md="6">
                                        <Card className="shadow-1">
                                            <Card.Body>
                                                <Row>
                                                    <Col xs="12" md="6">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Plantilla <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                className={`input-form ${errorGlobal && 'error'}`}
                                                                onChange={e => onHandleSelectPlantilla(e.target.value)}
                                                                value={plantDefault}
                                                            >
                                                                <option value="">Seleccionar plantilla</option>
                                                                {
                                                                    plantillaOpt.map((item,i)=>(
                                                                        <option key={i} value={item.key}>{item.name}</option>
                                                                    ))
                                                                }
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="12" md="6">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Bandera <span className="text-danger">*</span></Form.Label>
                                                            <Field
                                                                as="select"
                                                                className={`form-control input-form ${errors.appointmentMoment && 'error'}`}
                                                                name="appointmentMoment"
                                                            >
                                                                <option value="">Seleccionar</option>
                                                                {
                                                                    momentos.map((item, i)=>(
                                                                        <option value={item.key} key={i}>{item.label}</option>
                                                                    ))
                                                                }
                                                            </Field>
                                                            { errors.appointmentMoment && <div className="invalid-feedback d-block">{errors.appointmentMoment}</div> }
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Card className="shadow-1">
                                            <Card.Body>
                                                <h6 className="text-secondary">Etiquetas</h6>
                                                <ul className="m-0 list-inline">
                                                    <li className="list-inline-item"><span className="badge badge-info">#doctor-nombre</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#doctor-email</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#doctor-telefono</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#doctor-apellido</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#doctor-especialidad</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#fechacita</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#horacita</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-nombrecompleto</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-clientecorporativo</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#link-consulta</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#expediente-sise</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-documento-identidad</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-direccion</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-ciudad</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-telefono</span></li>
                                                    <li className="list-inline-item"><span className="badge badge-info">#paciente-diagnostico</span></li>
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs="12" md="12" className="mt-2">
                                <Card className="shadow-1">
                                    <Card.Body>
                                        <Row>
                                            <Col xs="12" md="12" style={showJodi ? {display:'block'} : {display:'none'}}>
                                            <React.StrictMode>
                                                <EmailEditor
                                                    ref={el => {
                                                        emailEditorRef.current = el
                                                        setRefVisible(!!el)
                                                    }}
                                                />
                                            </React.StrictMode>
                                                
                                            </Col> :
                                            <Col style={showJodi ? {display:'none'} : {display:'block'}}>
                                                <Jumbotron>
                                                    <h6 className="text-center">
                                                        Seleccionar  una plantilla
                                                    </h6>
                                                </Jumbotron>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {id && <Row className='mt-2'>
                            {isDeleting && <LoadingList texto="Procesando petición"/>}
                            <Col xs="12" md="12">
                                <Card className="shadow-1">
                                    <Card.Body>
                                        <Row>
                                            <Col xs="12" md="12">
                                            <div className="p-3 pt-4 position-relative">
                                                {
                                                    archivos.map((item, i)=>(
                                                        <Row key={i} className="mb-3">
                                                            <Col xs="7" md="4">
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="pr-2"> {getIconDoc(item.fileName)}</div>
                                                                    <div className="lh-1">
                                                                        <span className="d-block m-0 color-989898 font-size-09rem text-dark">{item.fileName}</span>
                                                                        <small className="color-989898">{moment(item.createDate).format("MMMM DD, YYYY HH:mm")}</small>
                                                                    </div>
                                                                </div>
                                                                
                                                            </Col>
                                                            <Col xs="2" md="2">
                                                                <span className="z-index-8 cursor-pointer" onClick={e=>{
                                                                    e.stopPropagation()
                                                                    deleteFile(item.fileName, item.id)
                                                                }}><RiDeleteBin2Line className="color-red" /></span>
                                                            </Col>
                                                        </Row>
                                                        
                                                    ))
                                                }

                                                <Row className='mt-1'>
                                                    <Col xs="8" md="7">
                                                        <label className="font-weight-bold-600 color-yellow font-size-09rem d-block">{t('agregar_archivo')}</label>
                                                    </Col>
                                                    <Col xs="12" md="12">                    
                                                        {errorFile && <small className="color-red">{errorFile}</small>}
                                                    </Col>

                                                    <Col xs="12" md="4">
                                                        {loading && <SimpleLoad />}
                                                        <button type="button" className="btn-block btn-file">
                                                            <ImAttachment className="d-block m-auto color-989898 font-size-13rem"/>
                                                            <span className='d-block color-989898 font-size-09rem'>Subir archivo</span>
                                                        </button>
                                                        <input
                                                            type="file"
                                                            ref={fileInputField}
                                                            className="input-file"
                                                            onChange={handleNewFileUpload}
                                                        />                    
                                                    </Col>
                                                    <Col xs="12" md="12">
                                                        <small className="text-muted">La capacidad máxima de subida de cada archivo es de 10MB</small>
                                                    </Col>                                                    
                                                </Row>
                                                <ComponentModalErrorSever 
                                                    show={showModalError}
                                                    handleClose={handleClose}
                                                    error={errorServer}
                                                />
                                            </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>}
                        <Row className="my-5">
                            <Col className="text-right">
                                <Link to="/admin/correos" className="btn btn-danger cancelar-buttom">Cancelar</Link>{' '}
                                <Button variant="outline-success" className="ok-buttom" type="submit">Agregar</Button>{' '}
                            </Col>
                        </Row>
                    </Form>
                )}
                </Formik>
            </Col>                
            }  

            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />         
            
        </Row>
    )
}

export default withTranslation()(FormCorreos)